<form [formGroup]="iconFormGroup">
  <div fxLayout="row" fxLayoutAlign="end center">
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center">
      <label mat-dialog-title class="icon-library-head">Icon library</label>
      <p class ="responsive-custom-icon-text">You can choose the suitable icon from this library</p>
    </div>

    <!-- <div mat-dialog-content fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
            <div  fxLayout="row" fxFlex="100" fxLayoutAlign="center center" style="width: 95% !important;">
                <div class="form-group" style="width: 100% !important;">
                    <div  class="input-icons" >
                        <mat-icon class="search-icon" >search</mat-icon>
                        <input type="email" class="form-control" style="width: 100%;padding-left: 40px;border-radius: 10px;"
                            placeholder="Search with the icon name..">
                    </div>
                </div>
            </div>
                
                <div fxLayout="row wrap" class="icon-list-section">
                    <div class="miniapps-img" fxLayout="column" style="margin: 5px;" fxLayoutAlign="center center" *ngFor="let icon of iconsList" >
                       
                        <div class="library-icon-img" fxLayoutAlign="center center"><mat-icon style="font-size: 20px;height: 20px;width:20px">{{icon.ligature}}</mat-icon></div>
                        <div  fxLayout="row"  fxLayoutAlign="center center"> <label class="icon-name">{{icon.name}}</label></div>
                       
                        
                    </div>
                </div>
        </div> -->
    <div class = "responsive-align-items-flex-start" fxLayout="row" fxLayoutGap="15" fxLayoutAlign="center center">
      <label>
        <input type="radio" name="icon" id="option1" formControlName="icon" value="registration"
          class="card-input-element" (change)="onclickOfIcon($event)" />
        <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;" *ngIf="iconFormGroup.controls.icon.value == 'registration'">
            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;">check_box
            </mat-icon>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center" class="p-2" >
            <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
              </svg>
            </div>
            <div class="template-icon-img"><img src="assets/profile-img.svg" /></div>
          </div>

        </div>
        <div fxLayoutAlign="center center" class="profile"><span>Profile</span></div>
      </label>
      <label>
        <input type="radio" name="icon" id="option2" formControlName="icon" value="edit-registration"
          class="card-input-element" (change)="onclickOfIcon($event)" />
        <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;" *ngIf="iconFormGroup.controls.icon.value == 'edit-registration'">
            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;">check_box
            </mat-icon>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center" class="p-2">
            <div class="tempalte-img">
              <svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
              </svg>
            </div>
            <div class="template-icon-img"><img src="assets/chg-md-img.svg" /></div>
          </div>
        </div>
        <div class="profile">
          <span>Change Medium</span>
        </div>
      </label>
      <label>
        <input type="radio" name="icon" id="option3" formControlName="icon" value="home" class="card-input-element"
          (change)="onclickOfIcon($event)" />
        <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;" *ngIf="iconFormGroup.controls.icon.value == 'home'">
            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;">check_box
            </mat-icon>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center" class="p-2">
            <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
              </svg>
            </div>
            <div class="template-icon-img"><img src="assets/home.svg" /></div>
          </div>

        </div>
        <div fxLayoutAlign="center center" class="profile"><span>Home</span></div>
      </label>
      <label>
        <input type="radio" name="icon" id="option4" formControlName="icon" value="edit-age" class="card-input-element"
          (change)="onclickOfIcon($event)" />
        <div fxLayout="column" class="miniapps-img card-input" fxLayoutAlign="center center">
          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;" *ngIf="iconFormGroup.controls.icon.value == 'edit-age'">
            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;">check_box
            </mat-icon>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center" class="p-2">
            <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
              </svg>
            </div>
            <div class="template-icon-img"><img src="assets/edit-age.svg" /></div>
          </div>

        </div>
        <div fxLayoutAlign="center center" class="profile"><span>Change Age</span></div>
      </label>

    </div>
    <div fxLayout="row" fxLayoutAlign="center center" style="width:100%">
      <button class="verify-btn responsive-max-width responsive-icon-popup-btn" fxFlex="30" fxLayoutAlign="center center" style="padding: 8px 0;"
        (click)="closePopup()">Cancel</button>
      <button class="verify-btn responsive-max-width responsive-icon-popup-btn" fxLayoutAlign="center center" fxFlex="30" style="padding: 8px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';
      font-style: normal;font-size: 14px; " (click)="saveIcon()">Save
      </button>
    </div>


  </div>
</form>